import { BootstrappedData } from './interfaces';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const Sentry: any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const R7Insight: any;
declare const bootstrapped: BootstrappedData;

export class Log {
    public static info(msg: string, additionalData?: unknown): void {
        Log.emitLogMessage('info', msg, additionalData);
    }

    public static warn(msg: string, additionalData?: unknown): void {
        Log.emitLogMessage('warn', msg, additionalData);
    }

    public static error(msg: string, additionalData?: unknown): void {
        Log.emitLogMessage('error', msg, additionalData);
    }

    private static staticAdditionalData: {
        [key: string]: string | number;
    } = {};

    public static addStaticAdditionalData(
        key: string,
        value: string | number,
    ): void {
        Log.staticAdditionalData[key] = value;
    }

    private static isR7Initialized = false;

    private static emitLogMessage(
        msgType: 'info' | 'warn' | 'error',
        msg: string,
        additionalData: unknown,
    ): void {
        console?.[msgType](msg, additionalData);
        Log.logToR7Insight(msgType, msg, additionalData);
        Log.logToSentry(msgType, msg, additionalData);
    }

    private static logToR7Insight(
        msgType: 'info' | 'warn' | 'error',
        msg: string,
        additionalData: unknown,
    ): void {
        if (typeof R7Insight === 'undefined') {
            return;
        }
        if (!Log.isR7Initialized) {
            R7Insight.init({
                token: bootstrapped.r7InsightToken,
                ['page_info']: 'per-page',
                region: 'eu',
            });
            Log.isR7Initialized = true;
        }

        if (additionalData) {
            R7Insight[msgType]({
                ...Log.staticAdditionalData,
                user: bootstrapped.userId,
                message: msg,
                data: additionalData,
            });
        } else {
            R7Insight[msgType]({
                ...Log.staticAdditionalData,
                user: bootstrapped.userId,
                message: msg,
            });
        }
    }

    private static logToSentry(
        msgType: 'info' | 'warn' | 'error',
        msg: string,
        additionalData: unknown,
    ): void {
        if (msgType === 'info') {
            return;
        }
        if (typeof Sentry === 'undefined') {
            return;
        }

        if (additionalData instanceof Error) {
            Sentry.captureException(additionalData, { level: msgType });
        } else {
            Sentry.captureMessage(msg, { level: msgType });
        }
    }
}
